module.exports = __webpack_public_path__ + "static/img/073.49ab97d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/073.png
// module id = lMDa
// module chunks = 0